{
	"nav": {
		"home": "Home",
		"catalog": "Course catalog",
		"library": "Library",
		"materials": "Materials",
		"favorites": "Favorites",
		"collections": "Folders",
		"notes": "Notes",
		"tests": "Tests",
		"flashcards": "Flashcards",
		"glossary": "Glossary",
		"tutor": "Tutor",
		"recording": "Lecture recording",
		"audioSummary": "Audio recap",
		"essays": "Essay grading",
		"visual": "Explain by photo",
		"voiceTutor": "Voice tutor",
		"plan": "Study plan",
		"calendar": "Calendar",
		"progress": "Progress",
		"weakSpots": "Weak spots",
		"trash": "Trash",
		"about": "About",
		"pricing": "Pricing",
		"help": "Help",
		"features": "Features",
		"method": "Method",
		"course": "Course",
		"howItWorks": "How it works",
		"faq": "FAQ",
		"section": {
			"tools": "Tools"
		},
		"more": "More",
		"planShort": "Plan",
		"characters": "Characters",
		"folders": "Folders",
		"courses": "Courses"
	},
	"topbar": {
		"search": "Search",
		"commandPalette": "Commands (⌘K)",
		"notifications": "Notifications",
		"profile": "Profile",
		"settings": "Settings",
		"billing": "Subscription",
		"help": "Help",
		"signOut": "Sign out",
		"searchOpen": "Open search",
		"searchPlaceholder": "Search materials, notes, flashcards…",
		"openMenu": "Open menu",
		"uploadMaterial": "Upload material",
		"home": "Home",
		"tutorOpen": "AI tutor",
		"tutorLabel": "Tutor",
		"themeLight": "Light theme",
		"themeDark": "Dark theme",
		"notificationsUnread": "Notifications ({count} unread)",
		"notificationsAll": "Notifications",
		"login": "Sign in",
		"trial": "Try it",
		"howItWorks": "How it works",
		"guestNav": "Site sections",
		"create": "Create"
	},
	"addMenu": {
		"title": "Create",
		"subtitle": "Start a course or bring in study material.",
		"course": {
			"title": "Course",
			"desc": "A program from a topic, a ready course from the catalog, or a space for your own materials"
		},
		"upload": {
			"title": "Upload material",
			"desc": "PDF, document, video, link or text"
		},
		"record": {
			"title": "Record a lecture",
			"desc": "A lecture turns into notes"
		},
		"discover": {
			"title": "Find on the internet",
			"desc": "Search the web (Fast or Deep) and save sources to a library folder",
			"hint": "Enter a topic — Fast finds sources, Deep also builds a report. Nothing is saved until you confirm.",
			"saveFolder": "Save {count, plural, one {# source} other {# sources}} to folder",
			"savedFolder": "Saved {count} sources to a library folder",
			"doneTitle": "Folder ready",
			"doneHint": "Open it in the library, or attach the whole folder to a course.",
			"openFolder": "Open in library",
			"attachHeading": "Attach folder to course",
			"attachedToCourse": "Folder added to the course",
			"attachFailed": "Couldn't add the folder to the course"
		}
	},
	"sidebar": {
		"ariaLabel": "Main navigation",
		"brand": "StudyHub — to home",
		"uploadMaterial": "Upload material",
		"studySets": "Folders",
		"allSets": "All folders",
		"collapse": "Collapse",
		"expand": "Expand sidebar",
		"collapseAria": "Collapse sidebar",
		"navAriaLabel": "App sections",
		"createSet": {
			"title": "Create folder",
			"subtitle": "Group materials by subject or course.",
			"nameLabel": "Name",
			"placeholder": "For example, Anatomy — 1st year",
			"descriptionLabel": "Description (optional)",
			"descriptionPlaceholder": "Short summary",
			"colorLabel": "Color",
			"materialsLabel": "Materials (optional)",
			"materialsPlaceholder": "Select materials",
			"materialsSelected": "{count, plural, one {# material selected} other {# materials selected}}",
			"materialsSearchPlaceholder": "Search by name…",
			"materialsEmpty": "No materials yet",
			"materialsNoMatches": "Nothing found",
			"materialsLimitReached": "Limit reached: {limit} materials",
			"cancel": "Cancel",
			"cta": "Create",
			"success": "Folder created",
			"error": "Could not create folder"
		},
		"create": "Create"
	},
	"tier": {
		"free": "Free",
		"plus": "Plus",
		"pro": "Pro",
		"planLabel": "{tier} plan"
	},
	"streak": {
		"days": "{count, plural, one {# day streak} other {# day streak}}",
		"encouragement": "Keep the momentum",
		"openAria": "Open streak details"
	},
	"promo": {
		"plusTitle": "Unlock Plus",
		"plusBody": "Unlimited AI generations and Live Lecture without caps",
		"plusCta": "Learn more"
	},
	"bottomNav": {
		"home": "Home",
		"materials": "Materials",
		"study": "Study",
		"tutor": "Tutor",
		"profile": "Profile"
	},
	"theme": {
		"label": "Theme",
		"light": "Light",
		"dark": "Dark",
		"system": "System",
		"useSystem": "Use system"
	},
	"language": {
		"label": "Language",
		"placeholder": "Choose language"
	},
	"userMenu": {
		"viewProfile": "View profile",
		"accountSettings": "Account settings",
		"subscription": "Subscription",
		"feedback": "Feedback"
	},
	"breadcrumbs": {
		"home": "Home"
	},
	"mobileDrawer": {
		"title": "Navigation menu",
		"description": "Full list of StudyHub sections",
		"navAriaLabel": "Extended navigation",
		"profile": "Profile"
	},
	"a11y": {
		"skipToContent": "Skip to content"
	},
	"panel": {
		"tutorTitle": "Tutor",
		"notificationsTitle": "Notifications",
		"close": "Close panel",
		"tutorAria": "Tutor panel",
		"notificationsAria": "Notifications panel",
		"tutorPlaceholder": "The tutor chat will appear here.",
		"notificationsPlaceholder": "The notifications feed will appear here."
	},
	"tooltips": {
		"tutor": "Open the AI tutor",
		"theme": "Switch theme",
		"notifications": "Notifications",
		"profile": "Profile and settings",
		"search": "Search (⌘K)",
		"collapseSidebar": "Collapse sidebar",
		"expandSidebar": "Expand sidebar"
	},
	"dailyLoad": {
		"eyebrow": "Today",
		"value": "{done} / {goal} min",
		"valueCompact": "{done}",
		"aria": "Today: {done} of {goal} minutes. Open progress"
	},
	"moduleState": {
		"product_disabled": {
			"title": "{module} is turned off",
			"description": "Your material is still here and you can read it. Creating new items in this section is closed for now."
		},
		"killed": {
			"title": "{module} is temporarily unavailable",
			"description": "We are already on it. Nothing was lost — creating new items is paused for a short while."
		},
		"tier_locked": {
			"title": "{module} is on a paid plan",
			"cta": "See plans",
			"description": "{module} opens up on a paid plan."
		},
		"platform_unsupported": {
			"title": "{module} is not available on this device",
			"description": "You can still open what you have created; working with the section requires a browser."
		},
		"dependency_missing": {
			"title": "{module} depends on a section that is off",
			"description": "This section needs another one that is currently turned off. Existing items stay readable."
		},
		"external_down": {
			"title": "The external service behind {module} is not responding",
			"description": "We are showing saved data. Please try again a little later."
		},
		"lifecycle_removed": {
			"title": "{module} has been retired",
			"description": "Existing items stay readable; new ones are no longer created in this section."
		}
	},
	"pullToRefresh": {
		"refreshing": "Refreshing…"
	}
}
